import { GridApi, Column, ProcessCellForExportParams } from 'ag-grid-community';
import { translateBlockValue } from 'i18n';
import {
    AGG_STATUS,
    BUDGET_LINE_ID,
} from 'routes/BudgetModule/config/constants';
import { statusFormatter } from 'ui/AgGridReact/formatters';
import { t } from 'i18next';
import { BudgetExpenseOrIncome } from 'business/constants';

type exportBudgetLinesProps = {
    expenseOrIncome: BudgetExpenseOrIncome;
    gridApi: GridApi | null;
};

/**
 * Export the agGrid content as excel. Used to export Budget Lines in Expense/Income view.
 */
export const exportBudgetLines = ({
    expenseOrIncome,
    gridApi,
}: exportBudgetLinesProps) => {
    const translationOptions = {
        option: translateBlockValue(expenseOrIncome),
    };
    const gridTitleImputations = t(
        'budgetProposal.imputationTableTitle',
        translationOptions,
    );

    // Exclude BUDGET_LINE_ID from the export.
    const displayedColumnsToExport = gridApi
        ?.getAllDisplayedColumns()
        ?.filter((col: Column) => !col.getColId().startsWith(BUDGET_LINE_ID));

    gridApi?.exportDataAsExcel({
        fileName: gridTitleImputations,
        columnKeys: displayedColumnsToExport,
        processCellCallback: (params: ProcessCellForExportParams) => {
            if (params.column.getColDef().field === AGG_STATUS) {
                // Status needs to be translated here since valueFormatter
                // is used by ag-grid for export
                return statusFormatter(params);
            }

            return params.value;
        },
    });
};
